'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import PrescriptionMismatch from './PrescriptionMismatch.react';
import MealCell from './MealCell.react';
import Dropdown from '../../Widgets/Dropdown.react';

import './MobileGrid.scss';

export default class MobileGrid extends Component {
    static contextTypes = {
        mismatches: PropTypes.object,
        onModifyMeals: PropTypes.func,
        getDefaultAddSwapSettings: PropTypes.func,
        hideWarnings: PropTypes.bool
    };

    render = () => {
        const { mismatches, onModifyMeals, hideWarnings } = this.context;
        const { plan, maxOffset, mealTypes, hideMismatches, profile = {} } = this.props;
        const { hide_nutrition = false, rd_override } = profile.preferences || {};

        const isAltPatient = profile?.type === "alternate-patient";
        let showDailyMismatches = mealTypes.includes('Breakfast') &&
                                  mealTypes.includes('Lunch') &&
                                  mealTypes.includes('Dinner') &&
                                  !hideMismatches &&
                                  (!hide_nutrition || rd_override);

        const offsets = [];

        for(var i = 0; i <= maxOffset; i++) {
            offsets.push(i);
        }

        return (
            <div className="mobile-grid">
                <div className="meal-types-column">
                    {mealTypes.map(mealType => (
                        <div key={mealType} className="meal-types-row">
                            <span>{mealType}</span>
                        </div>
                    ))}
                </div>

                <div className="meals-column-viewport">
                    <div className="meals-column-container">
                        {offsets.map(offset =>(
                            <div key={offset} className="meals-column-cell">
                                <div className="day-offset-header">
                                    Day {offset+1}

                                    {showDailyMismatches && mismatches[offset] && mismatches[offset]['all-day'] && mismatches[offset]['all-day'].length > 0 && !isAltPatient && !hideWarnings ?
                                        <Dropdown button={<i className="icon-warning1" />}>
                                            <PrescriptionMismatch mealType="Daily Totals"
                                                mismatches={(showDailyMismatches && mismatches[offset] && mismatches[offset]['all-day']) || []} />
                                        </Dropdown>
                                    : null}
                                </div>

                                {mealTypes.map(mealType => (
                                    <div key={mealType} className="meals-column-inner-container">
                                        <MealCell profile={profile} key={offset} offset={offset} mealType={mealType} plan={plan}
                                            meals={(plan.items || []).filter(meal => meal.offset == offset && meal.meal == mealType)} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
